import {VALIDATION_RULES} from "../../configs/validation";
import {getLocalizedField} from "../../utils/languageHelper";

/** Last-resort wording when a rule carries no message and the registry has no entry. */
const GENERIC_ERROR_MESSAGE = "This field is invalid"

export default class ValidationResult {
    hasError = false
    errorBuckets = {}

    /**
     * Check if the validation is successfully or not
     * @returns {boolean}
     */
    errors() {
        return this.hasError
    }

    /**
     * Add error and generate error message
     *
     * The message is resolved in the patient's language. saveForm's auto-translate already
     * writes errorMessageEs / errorMessageRu alongside every rule's errorMessage
     * (forms-api.js mergeTranslations) — this is the only place that reads them, so a
     * Spanish patient reads a Spanish message instead of the English default.
     *
     * @param {String} fieldName
     * @param {ValidationRule} validationRule
     * @param {String} language - 'en' | 'es' | 'ru'
     */
    addError(fieldName, validationRule, language = 'en') {
        this.hasError = true

        if (!this.errorBuckets[fieldName]) {
            this.errorBuckets[fieldName] = [];
        }

        // generate error message and add it
        const registryEntry = VALIDATION_RULES[validationRule.ruleType]
        let errorMessage =
            getLocalizedField(validationRule, 'errorMessage', language) ||
            validationRule.errorMessage ||
            (registryEntry && registryEntry.errorMessage) ||
            GENERIC_ERROR_MESSAGE

        // if it has replaceable variable => replace it (:mix, :max, :lol)
        const replaceableVar = `:${validationRule.ruleType}`
        if (errorMessage.indexOf(replaceableVar) >= 0) {
            errorMessage = errorMessage.replace(replaceableVar, validationRule.additionalValue)
        }

        // add the error message
        this.errorBuckets[fieldName].push(errorMessage)
    }
}
